export default __webpack_public_path__ + "static/media/ArrowBack.25490614.webp";